import { api } from "api/api";
import { AxiosError } from "axios";
import Conta from "model/administracao/cadastro/Conta";
import Perfil from "model/administracao/cadastro/Perfil";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import Horario from "model/gestao/atividades/Horario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class UsuarioService implements BaseServiceCadastros<Usuario> {
    
    

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null, idConta?: number | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/usuario/pesquisar`;
            url += getFilters(filters)
            if (idConta) {
                url += `${url.includes("?") ? "&" : "?"}idConta=${idConta}`;
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number, idConta?: number | null) {
        return new Promise<Usuario>((resolve, reject): void => {
            const params = idConta ? `?idConta=${idConta}` : '';
            api
                .get(`/usuario/consultar/${id}${params}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    perfis(idConta?: number) {
        return new Promise<Array<Perfil>>((resolve, reject): void => {
            let url = `/usuario/perfis`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    contasDoUsuario() {
        return new Promise<Array<Conta>>((resolve, reject): void => {
            let url = `/usuario/contasUsuario`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarSeEmailExiste(idConta: number|null, email: string) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/usuario/existsByEmail/${email}`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    setores(idConta?: number) {
        return new Promise<Array<Setor>>((resolve, reject): void => {
            let url = `/usuario/setores`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    horarios(idConta?: number) {
        return new Promise<Array<Horario>>((resolve, reject): void => {
            let url = `/usuario/horarios`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(usuario: Usuario, idConta?: number | null) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/incluir`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .post(url, JSON.stringify(usuario))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(usuario: Usuario, idConta?: number | null) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/editar`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .put(url, JSON.stringify(usuario))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editarUsuarioLogado(usuario: Usuario) {
        return new Promise<Usuario>((resolve, reject): void => {
            api
                .put(`/usuario/editar-usuario-logado`, JSON.stringify(usuario))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number, idConta?: number | null) {
        return new Promise<void>((resolve, reject): void => {
            const params = idConta ? `?idConta=${idConta}` : '';
            api
                .delete(`/usuario/excluir/${id}${params}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pessoas(idConta?: number) {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            let url = `/usuario/pessoas`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then((response) => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    getTiposDocumento(): any[] {
        return [
            { label: 'CPF', value: 'CPF' },
            { label: 'CNPJ', value: 'CNPJ' }
        ];
    }

}

export default UsuarioService;
